import { useStore } from '../store/useStore.js';

interface Props {
  onOpenShortcuts: () => void;
  onOpenTemplates: () => void;
}

function Icon({ name, size = 18 }: { name: string; size?: number }) {
  return <span className="material-symbols-outlined" style={{ fontSize: size }}>{name}</span>;
}

function FabBtn({
  children, label, kbd, onClick, primary, active, disabled,
}: {
  children: React.ReactNode;
  label: string;
  kbd?: string;
  onClick?: () => void;
  primary?: boolean;
  active?: boolean;
  disabled?: boolean;
}) {
  return (
    <button
      className={
        'syn-fab-btn' +
        (primary ? ' is-primary' : '') +
        (active ? ' is-active' : '')
      }
      onClick={onClick}
      disabled={disabled}
      title={label}
    >
      {children}
      <span className="syn-tip">
        <span>{label}</span>
        {kbd && <span className="tip-kbd">{kbd}</span>}
      </span>
    </button>
  );
}

function Sep() {
  return <div className="syn-fab-sep" />;
}

export function FloatingActionBar({ onOpenShortcuts, onOpenTemplates }: Props) {
  const selectedId = useStore((s) => s.selectedId);
  const undo = useStore((s) => s.undo);
  const redo = useStore((s) => s.redo);
  const zoomToFit = useStore((s) => s.zoomToFit);
  const autoLayout = useStore((s) => s.autoLayout);
  const addNode = useStore((s) => s.addNode);
  const history = useStore((s) => s.history);
  const historyIdx = useStore((s) => s.historyIdx);

  if (selectedId) return null;

  function handleAdd() {
    const state = useStore.getState();
    const cam = state.cam;
    addNode({
      label: 'Nova Ideia', type: 'idea', category: 'idea', icon: 'lightbulb',
      x: -cam.x + Math.random() * 200 - 100,
      y: -cam.y + Math.random() * 200 - 100,
      size: 22,
    });
  }

  return (
    <div className="syn-fab-wrap">
      <div className="syn-fab" role="toolbar">
        <FabBtn label="Criar nó" kbd="N" onClick={handleAdd} primary>
          <Icon name="add" size={20} />
        </FabBtn>

        <FabBtn label="Templates" kbd="⌘T" onClick={onOpenTemplates}>
          <Icon name="dashboard_customize" size={18} />
        </FabBtn>

        <Sep />

        <FabBtn label="Desfazer" kbd="⌘Z" onClick={undo} disabled={historyIdx <= 0}>
          <Icon name="undo" size={18} />
        </FabBtn>
        <FabBtn label="Refazer" kbd="⌘⇧Z" onClick={redo} disabled={historyIdx >= history.length - 1}>
          <Icon name="redo" size={18} />
        </FabBtn>

        <Sep />

        <FabBtn label="Centralizar grafo" kbd="F" onClick={zoomToFit}>
          <Icon name="filter_center_focus" size={18} />
        </FabBtn>
        <FabBtn label="Auto-layout" kbd="⌘L" onClick={autoLayout}>
          <Icon name="auto_fix_high" size={18} />
        </FabBtn>

        <Sep />

        <FabBtn label="Atalhos" kbd="?" onClick={onOpenShortcuts}>
          <Icon name="keyboard" size={18} />
        </FabBtn>
      </div>
    </div>
  );
}
